<template>
  <sc-page-base
  :title="title"
  :loading="loading">

    <sc-tabs
      type="is-boxed has-form"
      class="page-xml-cte-tags__tabs"
      :animated="false">
      <sc-tab-item label="Nova Tag">
        <sc-from-to-xml-cte />
      </sc-tab-item>

      <sc-tab-item label="Upload">
        <sc-file-import />
        <div class="box">
          <sc-file-import-table/>
        </div>
      </sc-tab-item>
    </sc-tabs>

  </sc-page-base>
</template>

<script>
import {
  ScPageBase,
  ScTabs,
  ScTabItem,
} from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';
import ScFromToXmlCte from './components/sc-from-to-xml-cte/ScFromToXmlCte';
import ScFileImport from './components/sc-file-import/ScFileImport';
import ScFileImportTable from './components/sc-file-import-table/ScFileImportTable';

const {
  mapState,
} = createNamespacedHelpers('recon/xmlCteTags');

export default {
  name: 'page-xml-cte-tags',
  data() {
    return {
      title: 'De x Para XML Documento Fiscal',
    };
  },
  computed: {
    ...mapState([
      'loading',
    ]),
  },
  components: {
    ScPageBase,
    ScTabs,
    ScTabItem,
    ScFromToXmlCte,
    ScFileImport,
    ScFileImportTable,
  },
};
</script>

<style lang="scss">
  .page-xml-cte-tags {
    &__tabs {
      .has-form + .tab-content {
        overflow: visible !important;

        .datepicker {
          z-index: 5;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/PageXmlCteTags.vue?abb2c6e2